export const SkyDark = () => ({
	backgroundDefault: '#1D1E59',
	backgroundPrimary: '#343471',
	backgroundPrimary60: '#232549',
	backgroundSecondary: '#111245',
});
